import useImage from "use-image";
import headToToeArrow from "../../../static/images/headToToeArrow.png";
import { useCallback } from "react";
import { Circle, Group, Image as KonvaImage } from "react-konva";

const ARROW_HEIGHT_RATIO = 0.72;
const HEAD_CIRCLE_OFFSET_RATIO = 0.115;

const ArrowOverlay = ({ cx, cy, angleDeg, imgW, imgH, onAngleChange }) => {
  const [arrowImg] = useImage(headToToeArrow, "anonymous");

  const arrowH = Math.min(imgW, imgH) * ARROW_HEIGHT_RATIO;
  const headDist = arrowH / 2 - arrowH * HEAD_CIRCLE_OFFSET_RATIO;

  const handleDragMove = useCallback(
    (e) => {
      const node = e.target;
      const stage = node.getStage();
      const pos = stage.getPointerPosition();
      if (!pos) return;

      const dx = pos.x - cx;
      const dy = pos.y - cy;
      const newRad = Math.atan2(dy, dx);
      const newDeg = ((newRad * 180) / Math.PI + 90 + 360) % 360;
      onAngleChange(newDeg);

      const snappedRad = ((newDeg - 90) * Math.PI) / 180;
      node.x(cx + headDist * Math.cos(snappedRad));
      node.y(cy + headDist * Math.sin(snappedRad));
    },
    [cx, cy, headDist, onAngleChange]
  );

  if (!arrowImg) return null;

  const arrowW = (arrowImg.naturalWidth / arrowImg.naturalHeight) * arrowH;
  const rad = ((angleDeg - 90) * Math.PI) / 180;
  const headHandleX = cx + headDist * Math.cos(rad);
  const headHandleY = cy + headDist * Math.sin(rad);

  return (
    <Group>
      <KonvaImage
        image={arrowImg}
        x={cx}
        y={cy}
        width={arrowW}
        height={arrowH}
        offsetX={arrowW / 2}
        offsetY={arrowH / 2}
        rotation={angleDeg}
        listening={false}
      />
      <Circle
        x={headHandleX}
        y={headHandleY}
        radius={35}
        fill="transparent"
        draggable
        onDragMove={handleDragMove}
        onDragEnd={(e) => {
          const snappedRad = ((angleDeg - 90) * Math.PI) / 180;
          e.target.x(cx + headDist * Math.cos(snappedRad));
          e.target.y(cy + headDist * Math.sin(snappedRad));
        }}
      />
    </Group>
  );
};

export default ArrowOverlay;
